import { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

// Messages come from the `support` catalog; each schema is built with the
// caller's translator (useTranslations on the client, getTranslations in actions).
type Translator = (key: string) => string;

const phoneSchema = (t: Translator) =>
    z.string().refine((val) => isValidPhoneNumber(val), t("phoneInvalid"));

export const buildCorporateApplicationSchema = (t: Translator) =>
    z.object({
        companyName: z.string().min(1, t("companyNameRequired")),
        companyPhone: phoneSchema(t),
        companyContact: z.string().min(1, t("companyContactRequired")),
        companyTitle: z.string().min(1, t("titleRequired")),
        companyEmail: z.string().email(t("emailInvalid")),
    });
export type CorporateApplicationFormData = z.infer<
    ReturnType<typeof buildCorporateApplicationSchema>
>;

export const buildIndividualApplicationSchema = (t: Translator) =>
    z.object({
        nameSurname: z.string().min(1, t("nameSurnameRequired")),
        phone: phoneSchema(t),
        email: z.string().email(t("emailInvalid")),
    });
export type IndividualApplicationFormData = z.infer<
    ReturnType<typeof buildIndividualApplicationSchema>
>;

export const buildEducationApplicationSchema = (t: Translator) =>
    z.object({
        schoolName: z.string().min(1, t("schoolNameRequired")),
        schoolPhone: phoneSchema(t),
        schoolContact: z.string().min(1, t("schoolContactRequired")),
        schoolTitle: z.string().min(1, t("titleRequired")),
        schoolEmail: z.string().email(t("emailInvalid")),
        schoolCount: z.string().min(1, t("countRequired")),
    });
export type EducationApplicationFormData = z.infer<
    ReturnType<typeof buildEducationApplicationSchema>
>;
